import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import {
  AgrPageDetailModule,
  AgrPrintPageModule,
  AgrValueRowModule,
} from '@next/core-lib/components';
import { AgrI18nSharedModule } from '@next/core-lib/i18n';
import { AgrTableModule } from '@next/core-lib/table';
import { LetDirective, PushPipe } from '@ngrx/component';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { SharedModule } from 'src/app/shared/shared.module';

import { CropFieldLegalStandardsComponent } from './components/crop-field-legal-standards/crop-field-legal-standards.component';
import { FertilizationLegalStandardsComponent } from './components/fertilization-legal-standards.component';
import { FertilizersOverviewComponent } from './components/fertilizers-overview/fertilizers-overview.component';
import { LegalStandardBalanceComponent } from './components/legal-standard-balance/legal-standard-balance.component';
import { FertilizationLegalStandardEffects } from './store/fertilization-legal-standard.effects';
import { fertilizationLegalStandardReducer } from './store/fertilization-legal-standard.reducer';

@NgModule({
  declarations: [
    FertilizationLegalStandardsComponent,
    CropFieldLegalStandardsComponent,
    LegalStandardBalanceComponent,
    FertilizersOverviewComponent,
  ],
  imports: [
    AgrPrintPageModule,
    MatDividerModule,
    LetDirective,
    PushPipe,
    AgrValueRowModule,
    CommonModule,
    SharedModule,
    AgrPageDetailModule,
    AgrI18nSharedModule,
    AgrTableModule,
  ],
  providers: [
    provideState('fertilizationLegalStandard', fertilizationLegalStandardReducer),
    provideEffects(FertilizationLegalStandardEffects),
  ],
})
export class FertilizationLegalStandardsModule {}
